/**
 * Constants for RecommendWorkerModal component
 */

// API Configuration
export const API_CONFIG = {
  MAX_RESULTS: 100,
  RESULTS_PER_REQUEST: 50,
  MAX_REQUESTS_WARNING: 10,
  CURSOR_INCREMENT: 50,
};

// Login Time Range Values
export const LOGIN_TIME_RANGES = {
  LAST_HOUR: 'last_hour',
  LAST_24_HOURS: 'last_24_hours',
  LAST_WEEK: 'last_week',
  LAST_TWO_WEEKS: 'last_two_weeks',
  LAST_MONTH: 'last_month',
  LAST_YEAR: 'last_year',
};

// UI Text Constants
export const UI_TEXT = {
  LOADING_MORE_CANDIDATES: 'dashboard.recommendWorkerModal.loadingMoreCandidates',
  LAST_LOGIN: 'dashboard.recommendWorkerModal.lastLogin.label',
  SEARCH_AGENCY: 'dashboard.recommendWorkerModal.agency.placeholder',
  SEARCH_RECRUITER: 'dashboard.recommendWorkerModal.recruiter.placeholder',
  DISTANCE: 'dashboard.recommendWorkerModal.distance.label',
  NO_FUTURE_WORK: 'dashboard.recommendWorkerModal.noFutureWork.label',
  INDUSTRY_MEETS_PREF: 'dashboard.recommendWorkerModal.industryMeetsPref.label',
  PAY_RATE_MEETS_PREF: 'dashboard.recommendWorkerModal.payRateMeetsPref.label',
  SHIFT_TIME_MEETS_PREF: 'dashboard.recommendWorkerModal.shiftTimeMeetsPref.label',
  WOTC_ELIGIBLE: 'userDetail.taxCredits.wotcEligible',
  URBAN_YOUTH_CERTIFIED: 'userDetail.taxCredits.urbanYouthCertified',
  FIND_MORE_WORKERS: 'dashboard.recommendWorkerModal.findMoreWorkers',
  NO_CANDIDATES: 'dashboard.recommendWorkerModal.noCandidates',
  LARGE_SEARCH_WARNING: 'dashboard.recommendWorkerModal.largeSearchWarning',
  FIND_WORKERS: 'dashboard.recommendWorkerModal.findWorkers',
  SEARCH: 'dashboard.recommendWorkerModal.search',
  SORT_BY: 'dashboard.recommendWorkerModal.sortBy',
  APPLY_FILTERS: 'dashboard.recommendWorkerModal.applyFilters',
  CLOSE: 'button.close',
  EMPLOYEE_NAME: 'dashboard.recommendWorkerModal.employeeName',
  INVALID_WORKERS: 'dashboard.recommendWorkerModal.invalidWorkers.title',
  INVALID_WORKERS_DESCRIPTION: 'dashboard.recommendWorkerModal.invalidWorkers.description',
  OVERTIME_BLOCKED: 'dashboard.recommendWorkerModal.invalidWorkers.overtimeBlocked',
  SUSPENDED: 'dashboard.recommendWorkerModal.invalidWorkers.suspended',
  NOT_QUALIFIED: 'dashboard.recommendWorkerModal.invalidWorkers.notQualified',
  CONFLICTING_SCHEDULE: 'dashboard.recommendWorkerModal.invalidWorkers.conflictingSchedule',
  INCOMPLETE_ONBOARDING: 'dashboard.recommendWorkerModal.invalidWorkers.incompleteOnboarding',
  IMPROPER_EOR_OR_JOB_FULL: 'dashboard.recommendWorkerModal.invalidWorkers.improperEorOrJobFull',
};

// Filter Default Values
export const FILTER_DEFAULTS = {
  NAME: '',
  PLACEMENT_SCORE: null,
  PAST_PLACEMENT_COUNT: null,
  LAST_LOGIN_DATE: LOGIN_TIME_RANGES.LAST_WEEK, // Default to one week
  AGENCY: null,
  RECRUITER: null,
  DISTANCE: null,
  NO_FUTURE_WORK: null,
  INDUSTRY_MEETS_PREF: false,
  PAY_RATE_MEETS_PREF: false,
  SHIFT_TIME_MEETS_PREF: false,
  WOTC_ELIGIBLE: false,
  URBAN_YOUTH_CERTIFIED: false,
  OVERTIME_BLOCKED: false,
  SUSPENDED: false,
  NOT_QUALIFIED: false,
  CONFLICTING_SCHEDULE: false,
  INCOMPLETE_ONBOARDING: false,
  IMPROPER_EOR_OR_JOB_FULL: false,
};

// Filter Keys
export const FILTER_KEYS = {
  NAME: 'name',
  RELIABILITY_SCORE: 'reliabilityScore',
  PLACEMENT_SUCCESS_SCORE: 'placementSuccessScore',
  AGENCY: 'agency',
  RECRUITER: 'recruiter',
  DISTANCE: 'distance',
  NO_FUTURE_WORK: 'noFutureWork',
  INDUSTRY_MEETS_PREF: 'industryMeetsPref',
  PAY_RATE_MEETS_PREF: 'payRateMeetsPref',
  SHIFT_TIME_MEETS_PREF: 'shiftTimeMeetsPref',
  WOTC_ELIGIBLE: 'wotcEligible',
  URBAN_YOUTH_CERTIFIED: 'urbanYouthCertified',
  LAST_LOGIN_DATE: 'lastLoginDate',
  SORT_BY: 'sortBy',
};

// Sort Option Values
export const SORT_OPTIONS = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
};

// Invalid Workers Filter Keys
export const INVALID_WORKER_FILTERS = {
  OVERTIME_BLOCKED: 'overtimeBlocked',
  SUSPENDED: 'suspended',
  NOT_QUALIFIED: 'notQualified',
  CONFLICTING_SCHEDULE: 'conflictingSchedule',
  INCOMPLETE_ONBOARDING: 'incompleteOnboarding',
  IMPROPER_EOR_OR_JOB_FULL: 'improperEorOrJobFull',
};
